// Display a preview of how the post will look in mobile app
import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import Images from '../../basics/Images';

const Preview = ({ brand, title, dateFrom, dateTo, description, images, videos, terms, source }) => {
  useEffect(() => {
  }, []);
  useEffect(() => {
    console.log('Preview images=', images);
  }, [images]);
  return (
    <>
      <div style={{ minHeight: '50vh', padding: 15 }}>
        <div className="row" style={{}}>
          <div className="col-md-12">
            <p style={{ color: '#000' }}>Preview of post in app:</p>
          </div>
        </div>

        <div className="row post-preview" style={{ backgroundColor: '#ffffff', padding: 0 }}>
          <div className="col-md-12" style={{ marginTop: 0, padding: 0 }}>
            {
              (videos && videos.length > 0)
                ? (
                  <ReactPlayer
                    url={videos[0]}
                    playing
                    volume={0}
                    loop
                    width="100%"
                    height="100%"
                    style={{ padding: 0, margin: 0 }}
                  />
                )
                : (
                  // eslint-disable-next-line jsx-a11y/alt-text
                  <img
                    style={{
                      position: 'relative',
                      width:    '100%',
                    }}
                    backgroundsize="cover"
                    src={(images && images.length > 0) ? images[0].display : Images.Local.Placeholder}
                  />
                )
            }
          </div>
          <div className="col-md-12 mt-3">
            <p style={{ fontSize: 14, fontWeight: 'bold' }}>{brand}</p>
          </div>
          <div className="col-md-12 title">
            {title}
          </div>
          <div className="col-md-12 dates" style={{ marginTop: 5 }}>
            {
              (dateFrom && dateTo)
                ? `${dateFrom} - ${dateTo}`
                : 'Period unspecified'
            }
          </div>
          <div
            className="col-md-12"
          >
            <Typography
              variant="body2"
              style={{
                wordWrap: 'break-word',
              }}
            >
              {description}
            </Typography>
          </div>
          <div className="col-md-12" style={{ marginTop: 5 }}>
            {terms}
          </div>
          <div className="col-md-12" style={{ marginTop: 5 }}>
            Source:
            {String(source).substr(0, 30).concat('...')}
          </div>
        </div>
      </div>
    </>
  );
};

Preview.postTypes = {
};
Preview.propTypes = {
  brand:       PropTypes.string,
  title:       PropTypes.string,
  dateFrom:    PropTypes.string,
  dateTo:      PropTypes.string,
  description: PropTypes.string,
  images:      PropTypes.array,
  videos:      PropTypes.array,
  terms:       PropTypes.string,
  source:      PropTypes.string,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null)(Preview);
